import "./Clinic.module.css";
import Cabecalho from "@/reusable_sections/Header";
import EnvironmentAndTechnology from "./sections/EnvironmentAndTechnology";
import NossaMissao from "./sections/NossaMissao";
import Rodape from "@/reusable_sections/Footer";
export default function ClinicPage() {
  return <div>
      <Cabecalho />
      <EnvironmentAndTechnology />
      <NossaMissao />
      <Rodape />
    </div>;
}